@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.drivergroups

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.drivergroups.DriverGroupDto
import com.narbase.letsgo.web.models.DriverGroupPurpose

object GetDriverGroupsEndpoint : EndPoint<GetDriverGroupsEndpoint.Request, GetDriverGroupsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
        @Suppress("NON_EXPORTABLE_TYPE") val driverGroupPurposes: DtoName<DriverGroupPurpose>?,
    )

    class Response(
        val list: Array<DriverGroupDto>,
        val total: Int
    )
}